import React, { Component } from "react"
import { Row, Col } from "antd"
import { Link } from "gatsby"
// import heroBackground from "../assets/images/hero.png"
import "./hero.scss"

class Hero extends Component {
  render() {
    const { bg, title, title_small, subTitle, info, customClass, getAQuote} = this.props
    return (
      <div className="hero-section">
        <div className="container">
          <Row>
            <Col
              className={`content ` + customClass}
              lg={14}
              md={24}
              sm={24}
              xs={24}
            >
              <span>{info}</span>
              <h1>{title}</h1>
              <h4>{title_small}</h4>
              <p>{subTitle}</p>
              {getAQuote ? <Link className="getAQuoteLink" to="/get-quote/">{getAQuote}</Link> : null}
            </Col>
            <Col lg={10} md={24} sm={24} xs={24}>
              <div className="hero-background">
                <img className="img1" src={bg} alt="background" />
              </div>
            </Col>
          </Row>
        </div>
      </div>
    )
  }
}

class HeroLeftImage extends Component {
  render() {
    const { bg, title, title_small, subTitle, customClass } = this.props
    return (
      <div className="hero-section">
        <div className="container">
          <Row>
            <Col className="content" lg={12} md={24} sm={24} xs={24}></Col>
            <Col
              className={`content` + customClass}
              lg={12}
              md={24}
              sm={24}
              xs={24}
            >
              <h1>{title}</h1>
              <p>{subTitle}</p>
            </Col>
          </Row>
        </div>
        <div className="hero-background-left">
          <img className="img1" src={bg} alt="background" />
        </div>
      </div>
    )
  }
}

export { HeroLeftImage, Hero }
// export default Hero;
